//AUTH
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";

// WIDGET CUSTOMIZE
export const SETTING_WIDGET = "SETTING_WIDGET";
export const SETTING_DISCOUNT = "SETTING_DISCOUNT";
